import Fuse from 'fuse.js';
import Link from 'next/link';
import { useEffect, useState } from 'react';

type Props = {
  site: any;
  categories: any;
};

export default function CategoriesSearch({ site, categories }: Props) {
  if (!site || !categories) {
    return <></>;
  }

  useEffect(() => {
    document.addEventListener('click', clickOutside);
    return () => {
      document.removeEventListener('click', clickOutside);
    };
  }, []);

  const clickOutside = () => {
    setResults([]);
  };

  let pages = [];
  categories.forEach((category) => {
    pages = pages.concat(category.children);
  });

  const [results, setResults] = useState<any>([]);

  const fuse = new Fuse(pages, {
    minMatchCharLength: 2,
    threshold: 0.3,
    keys: ['title'],
  });

  const search = (value: string) => {
    const results = fuse.search(value);
    setResults(results);
  };

  return (
    <div className="categories-search">
      <div className="search-input">
        <div className="icon">
          <img src="/assets/icons/search.svg" alt="search" width="24" height="24" loading="lazy" />
        </div>
        <input type="text" placeholder={site.tpl_search_input_placeholder} onChange={(e) => search(e.target.value)} />
      </div>
      {results.length > 0 && (
        <div className="search-results">
          {results.map((result) => {
            let item = result.item;
            return (
              <div className="result-item" key={item.title}>
                <Link href={item.url || '/'}>{item.title}</Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
